import { Mesh } from "three";
import { getBooleanPropBuilder } from "../FeatureUtils";

export type ModelContextPreset = Partial<Mesh>;

export const ModelContextPresets: Record<
  string,
  ModelContextPreset | ((userData: Record<string, any>) => ModelContextPreset)
> = {
  Invisible: getBooleanPropBuilder<ModelContextPreset>("Invisible", {
    visible: false,
  }),
};
